import { render, staticRenderFns } from "./DeleteMemberAccountForm.vue?vue&type=template&id=7beaf313&"
import script from "./DeleteMemberAccountForm.vue?vue&type=script&lang=js&"
export * from "./DeleteMemberAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports